<template>
  <div>
    <div class="wrapper wrapper-content">
      <div class="row">
        <div class="col-md-4">
          <div class="row">
            <company-details
              :company="myCompany"
              :groups="groups"
              :loading="$apollo.queries.myCompany.loading"
            ></company-details>
          </div>
          <div class="row">
            <plugins-list :plugins="plugins" :loading="loadingPlugins"></plugins-list>
          </div>
          <div class="row">
            <generate-u-r-l
              :companyUsers="companyUsers"
              :activeCampaigns="activeCampaigns"
              :generatedUrl="generatedUrl"
              :generateUrlSuccess="generateUrlSuccess"
              :loadingGenerateUrl="loadingGenerateUrl"
            ></generate-u-r-l>
          </div>
          <div class="row">
            <generate-permission-u-r-l
             v-if="hasPermissionPlugin"/>
          </div>
        </div>

        <div class="col-md-8">
          <user-list class="user-list" :users="companyUsers" :groups="groups" />
          <timeslot-list :timeslots="timeslots" />
          <blacklist-originator-list :blacklistedOriginators="blacklistedOriginators" />
          <email-recipient-list
            class="recipient-list"
            :me="me"
            :campaigns="campaigns"
            :companies="myCompanies"
            :surveys="surveys"
            :recipients="recipients"
            :users="emailUsers"
            :loading="$apollo.queries.recipients.loading"
            @deleted="refetchRecipients"
            @saved="refetchRecipients"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

import PluginsList from '@/components/plugin/PluginList';
import UserList from '@/components/user/UserList';
import TimeslotList from '@/components/timeslots/TimeslotList';
import BlacklistOriginatorList from '@/components/blacklist/BlacklistOriginatorList';
import EmailRecipientList from '@/components/automatedemails/recipients/EmailRecipientList';
import GenerateURL from '@/components/publishing/GenerateURL';
import GeneratePermissionURL from '@/components/permission/publishing/GeneratePermissionURL';

import myCompanyQuery from '@/graphql/accounts/myCompanyQuery.gql';
import myCompaniesQuery from '@/graphql/accounts/myCompaniesQuery.gql';
import listOrgUsersQuery from '@/graphql/accounts/listOrgUsersQuery.gql';
import recipientsQuery from '@/graphql/automatedemails/recipients/listRecipients.gql';

import CompanyDetails from './CompanyDetail';

export default {
  name: 'CompanyDashboard',
  components: {
    PluginsList,
    CompanyDetails,
    UserList,
    TimeslotList,
    BlacklistOriginatorList,
    EmailRecipientList,
    GenerateURL,
    GeneratePermissionURL,
  },
  data: () => ({
    organizationUsers: [],
    myCompanies: [],
    myCompany: null,
    recipients: [],
  }),
  apollo: {
    myCompanies: {
      client: 'apiv2',
      query: myCompaniesQuery,
      prefetch: true,
    },
    organizationUsers: {
      client: 'apiv2',
      query: listOrgUsersQuery,
      prefetch: true,
    },
    myCompany: {
      client: 'apiv2',
      query: myCompanyQuery,
      prefetch: true,
    },
    recipients: {
      client: 'apiv2',
      query: recipientsQuery,
      prefetch: true,
    },
  },
  computed: {
    ...mapState('blacklist', ['blacklistedOriginators']),
    ...mapState('timeslots', ['timeslots']),
    ...mapState('user', ['me', 'groups', 'companyUsers']),
    ...mapState('plugin', ['plugins', 'loadingPlugins']),
    ...mapState('campaign', ['campaigns']),
    ...mapState('company', ['companies']),
    ...mapState('survey', ['surveys']),
    ...mapGetters('campaign', ['activeCampaigns']),
    ...mapState('publishing', ['generatedUrl', 'loadingGenerateUrl', 'generateUrlSuccess']),
    emailUsers() {
      return this.organizationUsers.length ? this.organizationUsers : this.companyUsers;
    },
    hasPermissionPlugin() {
      return this.plugins.some(
        permission => permission.plugin_route === 'app.profiles.permissions');
    },
  },
  methods: {
    ...mapActions('company', ['updateCompany']),
    refetchRecipients() {
      this.$apollo.queries.recipients.refetch();
    },
  },
  mounted() {
    // this.$store.dispatch('company/getCompany');
    this.$store.dispatch('timeslots/getTimeslots');
    this.$store.dispatch('user/getGroups');
    this.$store.dispatch('user/getCompanyUsers');
    this.$store.dispatch('plugin/getPlugins');
    this.$store.dispatch('blacklist/getBlacklistedOriginators');
    this.$store.dispatch('campaign/getCampaigns');
    this.$store.dispatch('survey/getSurveys');
    this.$store.dispatch('company/getCompanies');
  },
  watch: {
    updatingCompanySucceeded() {
      if (this.updatingCompanySucceeded) {
        this.$emit('closeUpdateCompanyDialog');
        this.$store.dispatch('toast/success', 'Company successfully updated.');
      }
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// CompanyDashboard.vue?5da9e789